/* eslint-disable no-useless-escape */
import Vue from "vue";

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const ObjectToSortedArrayReverse = (obj = {}, sortBy) => {
  return Object.keys(obj)
    .map((key) => ({ id: key, ...obj[key] }))
    .sort((a, b) => a[sortBy] - b[sortBy]);
};

export const textExcerpt = (text, length) => {
  return text?.length > length ? text.substr(0, length - 1) + "..." : text;
};

export const generatePassword = (numChars) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let newPassword = "";
  for (let i = 0; i < numChars; i++) {
    newPassword += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return newPassword;
};

export const createModuleResetter = (getInitState) => (state) => {
  const initState = getInitState();
  for (const key in state) {
    const value = initState[key];
    if (typeof value !== "undefined") Vue.set(state, key, value);
    else Vue.delete(state, key);
  }
};

export const encodeAsFirebaseKey = (string) => {
  string = string.toLowerCase();

  return string
    .replace(/\./g, ",")
    .replace(/\#/g, "=")
    .replace(/\$/g, "+")
    .replace(/\//g, "-")
    .replace(/\[/g, "(")
    .replace(/\]/g, ")");
};

export const decodeFromFirebaseKey = (string) => {
  string = string.toLowerCase();

  return string
    .replace(/\,/g, ".")
    .replace(/\=/g, "#")
    .replace(/\+/g, "$")
    .replace(/\-/g, "/")
    .replace(/\(/g, "[")
    .replace(/\)/g, "]");
};
